import { EntityMultiSelect, Form } from '@domain-group/suit-theme'

import useBrands from '@hooks/useBrands'

import useBulkCreateBrandProviderModal from '../../hooks/useBulkCreateBrandProviderModal'

type SelectBrandsProps = {
  bulkCreateBrandProviderPayload: ReturnType<typeof useBulkCreateBrandProviderModal>,
}

const SelectBrands = (props: SelectBrandsProps) => {
  const { bulkCreateBrandProviderPayload } = props

  const {
    brands,
    callbacks: {
      setSelectedEntityIds,
      setState,
    },
    debouncedString,
    selectedEntityIds,
    string,
  } = bulkCreateBrandProviderPayload

  const brandsPayload = useBrands({
    filters: { string: debouncedString },
    performHttpRequests: debouncedString.length > 1,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredBrands,
    filteredBrandsCount,
    loading,
  } = brandsPayload

  const filteredBrandIds = debouncedString.length > 1 ? filteredBrands.map(brand => brand.id) : []

  return (
    <>
      <Form.Field label="Search Brands">
        <input onChange={e => setState({ string: e.target.value })} value={string} />
      </Form.Field>

      {/*
       // @ts-expect-error TS2741 */}
      <EntityMultiSelect
        boxProps={{ marginTop: 'large' }}
        callbacks={{
          loadMore,
          setSelectedIds: setSelectedEntityIds,
        }}
        canLoadMore={canLoadMore}
        entities={brands}
        entityCount={filteredBrandsCount}
        filteredEntityIds={filteredBrandIds}
        loading={loading}
        selectedIds={selectedEntityIds}
      />
    </>
  )
}

export default SelectBrands
